<template>
  <div class="food-beverage">
    <s-r-m-header ref="header" />
    <carousel-container ref="carouselContainer" :carouselInfo="carouselInfo" dark />
    <PointOfPain 
      :listData="listData" 
      title="食品饮料行业PLM的行业痛点以及解决方案"
      description="AI+PLM双引擎驱动，实现“合规生产、智能研发”"
    />
    <PointOfPain 
      :isTriangle="true"
      :isThree="true"
      :listData="listData2" 
      triangleContent="解决方案"
    />
    <!-- <PlatformOverview></PlatformOverview> -->
    <CoreStrengths
      title="食品饮料行业PLM的核心功能"
      description="针对食品饮料行业的特性，覆盖产品与竞品管理、物料管理、 包装和标签管理、配方设计、工艺管理、检测管理、安评备案等主要功能"
      :otherTopList="coreStrengthList"
    ></CoreStrengths>
    <p-l-m-a-i-application theme="blue" />
    <!-- <product-features
      title="璞华易研PLM（流程行业）的主要功能"
      description="为化工材料、食品饮料、日化等行业客户提供核心技术管理、资源池管理、效率工具、五大基石、数据建模"
      :tabList="tabList"
    ></product-features> -->
    <PointOfPain 
      :listData="technicalBrillianceData" 
      title="食品饮料行业PLM的主要特点"
    />
    <success-cases
      ref="successCases"
      title="璞华易研PLM的典型案例"
      description="多行业领域的实施经验提供更加垂直化的解决方案，助力企业提升研发效率"
      :caseList="caseList"
    />
    <KeyAdvantages :banner-height="bannerHeight2"></KeyAdvantages>
    <!-- <Scheme :schemeList="schemeList"></Scheme>  -->
    <ChooseUs :nameVals="['ChemicalIndustry', 'Food', 'Pharmaceutical', 'WearMakeup']" :scrollNum="3"></ChooseUs>
    <custom-form ref="customForm" />
    <footer-box />
  </div>
</template>

<script>
import CoreStrengths from "@/components/CoreStrengths"
import SRMHeader from "@/components/SRMHeader/index";
import CarouselContainer from "@/components/CarouselContainer/single"
import PointOfPain from "@/components/PointOfPain/index"
import PlatformOverview from "@/components/PlatformOverview"
import ProductFeatures from "@/components/ProductFeatures"
import SuccessCases from "@/components/SuccessCases"
import KeyAdvantages from "@/components/KeyAdvantages"
import PLMAIApplication from "@/components/PLMAIApplication"
import Scheme from "@/components/Scheme"
import ChooseUs from "@/components/ChooseUs"
import CustomForm from "@/components/Form"
import FooterBox from "@/components/FooterBox"
import { baiduConsult } from "./common.js";

import hgs1 from '@/assets/images/zym-sp.png'
import gn1 from '@/assets/images/gn1-1.png'
import gn2 from '@/assets/images/gn1-2.png'
import gn3 from '@/assets/images/gn1-3.png'
import gn4 from '@/assets/images/gn1-4.png'
import gn5 from '@/assets/images/gn1-5.png'

import al1 from '@/assets/images/al1-1.png'
import al2 from '@/assets/images/al1-2.png'
import al3 from '@/assets/images/al1-3.png'

import al8 from '@/assets/images/al1-8.jpg'
import al9 from '@/assets/images/al1-9.jpg'
import al10 from '@/assets/images/al1-10.jpg'


import hg1 from '@/assets/images/hg1.png'
import hg2 from '@/assets/images/hg2.png'
import hg3 from '@/assets/images/hg3.png'
import hg4 from '@/assets/images/hg4.png'
import hg5 from '@/assets/images/hg5.png'

import dz1 from '@/assets/images/dz1.png'
import dz2 from '@/assets/images/dz2.png'
import dz3 from '@/assets/images/dz3.png'
import dz4 from '@/assets/images/dz4.png'
import dz5 from '@/assets/images/dz5.png'
import dz6 from '@/assets/images/dz6.png'

import hx01 from '@/assets/images/hx-1.png'
import hx02 from '@/assets/images/hx-2.png'
import hx1 from '@/assets/images/hx1.png'
import hx2 from '@/assets/images/hx2.png'
import hx3 from '@/assets/images/hx3.png'
import hx4 from '@/assets/images/hx4.png'
import hx5 from '@/assets/images/hx5.png'
import hx6 from '@/assets/images/hx6.png'
import hx7 from '@/assets/images/hx7.png'



export default {
  components: {
    SRMHeader,
    CarouselContainer,
    PointOfPain,
    CustomForm,
    FooterBox,
    ProductFeatures,
    Scheme,
    PlatformOverview,
    ChooseUs,
    SuccessCases,
    KeyAdvantages,
    PLMAIApplication,
    CoreStrengths
  },
  metaInfo() {
    return {
      title: '食品PLM软件_饮料PLM系统_食品饮料行业PLM平台解决方案_国产PLM供应商_PLM厂家_PLM产品_PLM排名',
      meta: [
        {
          name: 'keywords',
          content: '食品PLM,饮料PLM,食品饮品PLM,食品配方管理,食品研发管理'
        },
        {
          name: 'description',
          content: '璞华易研PLM 系统，提供食品饮料PLM，食品餐饮PLM、调味料PLM、食品配方管理系统、食品研发管理系统，实现从原料溯源到配方优化、生产合规的全流程管控。保障食品安全，加速新品研发与上市，提升企业在食品市场的竞争力。'
        }
      ]
    }
  },
  data() {
    return {
      ratio: null,
      bannerHeight2: null,
      carouselInfo: {
        title: '食品饮料行业PLM',
        description: '食品、饮料、乳制品、调味品、预制菜、保健品、宠物食品..... <br/> 基于AI智能合规引擎与全流程数字化技术，覆盖从研发到上市的安全生命周期管理 ',
        bg: hgs1
      },
      technicalBrillianceData: [
        {
          num: '01',
          title: 'AI深度赋能',
          contentList: [
            {
              content: '配方推荐引擎：基于2000+历史配方数据训练，通过AI算法整合历史配方数据、成分功效数据库及消费者偏好分析，生成创新配方建议。推荐准确率超85%。'
            },
            {
              content: '自动化合规引擎：AI实时抓取170+国家法规更新（如欧盟、中国新条例），自动生成合规标签与安全数据表（SDS），某企业法规审核时间从数周缩短至24小时。'
            }
          ]
        },
        {
          num: '02',
          title: '全链路数字化',
          contentList: [
            {
              content: '云端协同：支持多地研发团队实时编辑配方（冲突自动合并），版本管理精度达秒级'
            },
            {
              content: '设备互联：对接电子天平/IoT设备，自动采集数据并生成试制报告（减少80%人工录入）'
            }
          ]
        },
        {
          num: '03',
          title: '包装标签管理',
          contentList: [
            {
              content: '产品与包装数据同步：使用填充了来自 PLM 和互联数据库的配方、过敏原、营养和监管数据的模板，快速开发、获取和更新标签'
            }
          ]
        },
        {
          num: '04',
          title: '简化工作流程',
          contentList: [
            {
              content: '使用内置工作流高效管理任务。了解研发、设计、包装和供应决策对成本、交付等的影响，同时最大限度地提高效率。'
            }
          ]
        },
      ],
      coreStrengthList: [
        {
          val: '01',
          title: '需求管理',
          contentImg: hx01,
          description: '市场需求模板化（含功效/成分/包装要求）、AI需求价值评估（ROI预测）'
        },
        {
          val: '02',
          title: '立项与项目管控',
          contentImg: hx02,
          description: '多维度项目模板库（新原料开发/方法开发）、资源负荷分析（设备/物料/人员）'
        },
        {
          val: '03',
          title: '产品和竞品管理',
          contentImg: hx1,
          description: '竞品分析、市场洞察、成本控制、合规管理等关键能力，助力企业提升竞争力，优化产品生命周期管理，实现高效决策与创新发展'
        },
        {
          val: '04',
          title: '物料管理',
          contentImg: hx2,
          description: '智能物料库（支持CAS/INCI双编码）、物质成分、营养元素库、研发物料库存管理可维护供应商及供应状态、市场价、成交价、理化值、营养值、法规及标准。原料数据将用于配方的计算'
        },
        {
          val: '05',
          title: '包装和标签管理',
          contentImg: hx3,
          description: '法规合规、内容管理、数据准确、设计协同、供应链整合、质量追溯、品牌保护、成本优化'
        },
        {
          val: '06',
          title: '配方设计',
          contentImg: hx4,
          description: '1，多配方协同设计（支持Excel/在线协调）、AI成分推荐（基于功效+法规+成本）、合规预警、BOM营养元素占比核对。2，理化指标计算：根据原料成分的用量，累加后得到配方的理化值，如水分、蛋白质、脂肪、碳水化合物、重金，以及微生物值。3，可定义不同的配方模板，模板之间内容相互独立，每套模板有特定的数据内容、计算方式、输出格式'
        },
        {
          val: '07',
          title: '工艺管理',
          contentImg: hx5,
          description: '支持建立行业通用工艺路线模板（如香精、乳化剂、色素）、BOM自动下发（支持版本锁定）'
        },
        {
          val: '09',
          title: '检测管理',
          contentImg: hx6,
          description: '检测方案智能生成（如微生物限度检测项目自动配置）、数据看板（稳定性趋势分析）'
        },
        {
          val: '10',
          title: '安评备案',
          contentImg: hx7,
          description: '备案文档智能组装（自动匹配区域模板）、合规性自检（法规条款、包装文案一键比对）'
        }
      ],
      tabList: [
        {
          name: 'first',
          label: '技术核心管理',
          title: '1. 技术核心管理',
          description: '围绕需求与实验，精细化管理资源池，实现高效的后勤保障、资源调度与资源复用',
          effectDrawing: gn1,
          contentList: [
            {
              title1: '配方管理',
              content1: 'BOM结构化、正反结构查询、替代料管理、自动计算、研发/生产多场景视图、版本比较'
            },
            {
              title1: '工艺管理',
              content1: '文件模板化、参数指标结构化、图文表并茂式呈现、单/多工序场景差异化维护、装备设备管理'
            },
            {
              
              title1: '实验过程管理',
              content1: '配方工艺多途径维护、样品物性数据可视化对比、自动出具实验与检验报告、权限多维度细分'
            },
            {
              title1: '材料成本分析',
              content1: '配方材料成本自动计算、物料价格走势图表化比对'
            },
            {
              title1: '配方成本预测',
              content1: '物料价格影响利润预测、配方成本虚拟运算、浮动情况可视化比较'
            }
          ]
        },
        {
          name: 'second',
          label: '资源池管理',
          title: '2. 资源池管理',
          description: '以配方、工艺、成本为核心，整合产品全生命周期数据，涓汇、沉淀经验库',
          effectDrawing: gn2,
          contentList: [
            {
              title1: '配方高级检索',
              content1: 'B支持以物性要求、原料占比等多条件维度检索产品配方资源池，获取适配的历史经验参考'
            },
            {
              title1: '实验设备看板',
              content1: '支持设备资产管理，动态维护实验设备状态，预约协调档期，利用率、故障率可视化统计'
            },
            {
              title1: '实验人员看板',
              content1: '支持看板动态维护实验人员状态，预约、协调其档期，支持工时统计、比较'
            },
            {
              title1: '实验物料库存',
              content1: '支持实验物料出入库管理，自动扣减实验打样所耗物料，提供呆滞料数量、价值可视化统计'
            },
            {
              title1: '模具耗材管理',
              content1: '提供实验模具、耗材等出入库管理台账，自动分配编号批号，助力资源库存预警，及时补货备货'
            }
          ]
        },
        {
          name: 'third',
          label: '效率工具',
          title: '3. 效率工具',
          description: '基于提质增效目标，配套灵活的个性化效率工具，助力研发活动响应效率',
          effectDrawing: gn3,
          contentList: [
            {
              title1: '系统模板',
              content1: '内置多套材料化工行业文件模板方案，支持用户个性化自定义、扩展'
            },
            {
              title1: '代办授权',
              content1: '支持业务流程临时委托代办授权，支持各对象读写用临时授权，配套快速审核等在线监督机制'
            },
            {
              title1: '流程效率分析',
              content1: '提供业务流程效率分析，支持以流程类型、流转节点、操作者等多维度分析业务流转效率'
            },
            {
              title1: '在线可视化',
              content1: '采用最新的BS架构，支持40多种主流的文件格式在线预览，所见即所得；配套多场景自动图表'
            },
            {
              title1: '第三方集成',
              content1: '自带主流的集成接口，轻松实现与ERP、MES、办公软件等的集成协同，支持数据导出'
            }
          ]
        },
        {
          name: 'four',
          label: '五大基石',
          title: '4. 五大基石',
          description: '内置材料化工通用的业务对象管理，为产品履历、数据分析、知识传承奠定坚实的基础',
          effectDrawing: gn4,
          contentList: [
            {
              title1: '物料',
              content1: '编码规则自定义、型号/牌号关联、属性配置、生命周期管理、版本管理、分类分组定义、自动转码等'
            },
            {
              title1: '文档',
              content1: '内置行业常用文档模型（如标准法规、检验规范、检测项目等），支持自定义扩展、分类分组管理等'
            },
            {
              title1: '流程',
              content1: '内置行业常用ECR-ECO变更方案，提供行业领先的用户可编程引擎，支持拖曳式自定义配置'
            },
            {
              title1: '报表',
              content1: '预置多场景自动图表（如对比图、统计图、走势图等）与分析表单，支持导出与打印'
            },
            {
              title1: '项目',
              content1: '项目计划+项目进度+项目交付+项目报表，帮助企业实现项目集管理，规范项目数据，缩短研发周期'
            }
          ]
        },
        {
          name: 'five',
          label: '数据建模',
          title: '5. 数据建模',
          description: '通过数据建模，支持客户个性化需求的高效灵活扩展，适应企业业务的发展衍变',
          effectDrawing: gn5,
          contentList: [
            {
              title1: '模型管理',
              content1: '支持数据、流程、字段级别的数据建模和精细化的权限控制'
            },
            {
              title1: '配置扩展',
              content1: '支持根据客户的个性化需求配置基础设置、对象分类、对象属性、工作流程、权限等'
            },
            {
              title1: '编码版本',
              content1: '支持适配企业体系化管理的各种编码、版本规则定义，支持内部文件与外来文件的差异化管理'
            },
            {
              title1: '用户管理',
              content1: '组织架构管理、用户信息管理、隶属关系管理、状态管理、行为日志、角色关联列表'
            },
            {
              title1: '角色权限',
              content1: '角色配置、用户关联、字段级数据权限、菜单权限、页签权限、按钮权限、读写权限'
            }
          ]
        }
      ],
      caseList: [
        {
          label: '伊利集团PLM系统优化升级',
          link: 'https://www.plmcenter.cn/cases/case-yili/',
          describe: '在2023年，伊利集团成功完成了PDM一期项目，搭建起PDM基础能力架构，涵盖技术底层、配方管理、数据管理以及权限管理等关键领域，实现了业务流程的初步贯通。然而，随着业务部门使用的不断深入和对功能体验要求的提升，逐渐暴露出一些亟待解决的问题。',
          advantage: ['搜索优化全面提升', 'BI图标功能完善'],
          img: al8
        },
        {
          label: '雅道生物PLM数字化转型',
          link: 'https://www.plmcenter.cn/cases/case-yadao/',
          describe: '配方全生命周期管理、配方权限管理、预混库管理、系统集成及法规合规支持等需求，需解决配方转生产衔接、核心数据安全与跨系统协同问题。',
          advantage: ['物料管理规范化', '配方管控精细化'],
          img: al9
        },
        {
          label: '耀目宠物食品PLM数字化转型',
          link: 'https://www.plmcenter.cn/cases/case-yaomu/',
          describe: '研发数据分散管理混乱、研发协同效率低下、配方与生产协同低效、知识沉淀与复用不足，传统管理模式面临多重瓶颈。',
          advantage: ['研发流程标准化', '数据统一管理'],
          img: al10
        }
      ],
      schemeList: [
        {
          val: '01',
          label: '化工材料行业',
          title: '应用场景',
          descriptions: [
            '目前，世界范围内化工产业发展迅速，新产品不断推出。同时，市场竞争加剧，产品同质化倾向比较明显，对数字化转型的要求也越来越高。需要覆盖产品全生命周期的闭环研发体系、跨部门跨地域的协同研发体系、基于数据收集和分析的数据建模数据管理体系、以及与第三方系统进行高效对接的系统集成机制。', 
            '璞华易研PLM基于10多年的PLM咨询实施经验，因应化工行业的发展需求，为化工行业提供最佳实践。',
            '我们在化工行业拥有丰富的咨询和实施经验，为客户在激烈的市场竞争中提升产品竞争力。'
          ],
          mainDesc: '化工材料行业的PLM应用主要包括以下主要内容。',
          mianFeatures: [
            { icon: hg1, label: '实验室管理' },
            { icon: hg2, label: '配方管理' },
            { icon: hg3, label: '工艺管理' },
            { icon: hg4, label: '物料管理' },
            { icon: hg5, label: '第三方工具集成' }
          ]
        },
        {
          val: '02',
          label: '电子高科技',
          title: '应用场景',
          descriptions: [
            '最近几年，电子高科技行业呈现出激烈的竞争局面，产品上市速度快，具有创新性的产品也不断推出。要在电子产品领域赢得竞争，必须面向消费者、关注设计、富有创新、快速推向市场，产品的全生命周期管理显得越来越重要。',
            '为了因应这一时代潮流，璞华易研PLM关注数据建模和数据管理，通过项目管理和变更管理，推动部门之间、地域之间进行无缝协作，强化与第三方系统的对接，让产品生命周期管理变得快捷、高效。'
          ],
          mainDesc: '电子高科技行业的PLM应用主要包括以下主要内容。',
          mianFeatures: [
            { icon: dz1, label: '数据管理' },
            { icon: dz2, label: '数据建模' },
            { icon: dz3, label: '变更管理' },
            { icon: dz4, label: '项目管理' },
            { icon: dz5, label: '在线可视化' },
            { icon: dz6, label: '第三方接入' }
          ]
        },
        {
          val: '03',
          label: '芯片半导体',
          title: '应用场景',
          descriptions: [
            '设计成本上涨、产品日益复杂、创新步伐加快，这些均给半导体企业造成很大的压力。该行业研发设计挑战艰巨、生命周期日益缩短。璞华易研PLM，帮助芯片半导体客户极大的改善了新产品开发和生命周期的流程管理。'
          ],
          mainDesc: '芯片半导体行业的PLM应用主要包括以下主要内容',
          mianFeatures: [
            { icon: dz1, label: '数据管理' },
            { icon: dz2, label: '数据建模' },
            { icon: dz3, label: '变更管理' },
            { icon: dz4, label: '项目管理' },
            { icon: dz5, label: '在线可视化' },
            { icon: dz6, label: '第三方接入' }
          ]
        },
        {
          val: '04',
          label: '医疗器械',
          title: '应用场景',
          descriptions: [
            '医疗器械行业对产品安全性和有效性要求特别高，因此对产品的设计、生产过程要求尤其严格。',
            '医疗器械制造商的竞争也日趋激烈，使得企业在产品管理方面迫切需要通过一种更为系统化、更为全面、更高效的产品生命周期管理方法以及对应的管理平台来迎接这些新挑战。',
          ],
          mainDesc: '医疗器械行业的PLM应用主要包括以下主要内容。',
          mianFeatures: [
            { icon: hg1, label: '实验室管理' },
            { icon: hg2, label: '配方管理' },
            { icon: hg3, label: '工艺管理' },
            { icon: hg4, label: '物料管理' },
            { icon: hg5, label: '第三方工具集成' }
          ]
        },
        {
          val: '05',
          label: '工业制造',
          title: '应用场景',
          descriptions: [
            '工业设备等制造业的分工合作越来越细，而部门的相对独立以及客户化定制要求，导致产品研制周期长且协同较少，研发部门到生产部门往往只有纸质文件传递，这对企业的设计生产方式、管理模式提出了严峻挑战。',
            '企业实施PLM项目管理可以使产品开发管理更加精细化，通过细化项目管理颗粒度，打破研发过程中部门之间的壁垒，从而实现研发、工艺、制造计划的协同分工与统筹安排。',
            '璞华易研PLM能帮助企业在管理和工作效率方面得到极大提升，实现上游技术部门和下游生产制造部门之间信息及时传递和共享。'
          ],
          mainDesc: '工业制造行业的PLM应用主要包括以下主要内容。',
          mianFeatures: [
            { icon: hg1, label: '实验室管理' },
            { icon: hg2, label: '配方管理' },
            { icon: hg3, label: '工艺管理' },
            { icon: hg4, label: '物料管理' },
            { icon: hg5, label: '第三方工具集成' }
          ]
        }
      ],
      listData: [
        {
          num: '01',
          title: '技术传承断层与研发低效',
          contentList: [
            {
              content: '技术传承困难：内部知识传递缺乏系统化记录和传承机制'
            },
            {
              content: '研发效率低下：配方、文档、工艺数据分散存储（Excel/纸质文件）或 在多个系统，难以快速查找和复用'
            },
            {
              content: '创新难度大：缺乏对现有研发数据的整合和分析，难以快速发现新的研发方向和改进点'
            }
          ]
        },
        {
          num: '02',
          title: '合规与备案风险高企',
          contentList: [
            {
              content: '法规更新频繁：食品饮料行业法规复杂且更新频繁，企业难以及时掌握法规变化'
            },
            {
              content: '合规成本高：企业需要投入大量人力和时间进行法规研究和合规性检查。平均每个新产品备案所需时间太长，期间的人力成本和时间成本显著增加'
            },
            {
              content: '备案失败风险：缺乏有效的合规管理工具，企业备案失败率较高，导致产品上市延迟，市场机会流失'
            },
            {
              content: '安评报告人工编制效率低（单份耗时3-5天），法规更新滞后导致合规错误率超15%'
            }
          ]
        },
        {
          num: '03',
          title: '研产协同与成本控制难题',
          contentList: [
            {
              content: '信息传递不及时：研发与工厂等部门之间信息传递不及时，导致生产过程中的配方变更频繁，生产效率下降'
            },
            {
              content: '成本控制困难：成本控制缺乏有效的数据支持，原材料采购、生产过程中的浪费和库存管理等问题难以优化'
            },
            {
              content: '库存管理复杂：原材料和成品的保质期要求严格，原材料过期浪费或成品积压，导致成本占增加'
            }
          ]
        },
        {
          num: '04',
          title: '数据安全与质量追溯薄弱',
          contentList: [
            {
              content: '技术数据权限管控粗放，部分企业泄密风险年损失超百万级'
            },
            {
              content: '实验记录缺失，质量追溯依赖人工复盘，问题定位平均耗时过长'
            },
            {
              content: '数据分散在多个系统中，缺乏统一管理，导致数据安全风险高'
            }
          ]
        }
      ],
      listData2: [
        {
          num: '05',
          title: 'AI智能合规引擎',
          contentList: [
            {
              content: '及时反映法规变化：PLM系统内置法规管理模块，实时更新法规要求，帮助企业快速掌握法规变化，因法规更新导致的合规性检查失败率从20%降低至5%，备案进度延迟率可从30%降低至10%'
            },
            {
              content: '自动合规检查：提供自动合规检查工具，确保产品配方、标签和生产工艺符合最新法规标准。备案失败率可从15%降低至5%，显著减少备案时间和成本'
            },
            {
              content: '智能安评报告生成：基于NLP技术解析实验数据，自动生成检测报告，效率提升70%'
            }
          ]
        },
        {
          num: '06',
          title: '全流程数字化管理平台',
          contentList: [
            {
              content: '需求-立项-交付闭环：支持市场部需求快速导入（模板化），AI自动匹配相似项目模板，立项周期缩短50%'
            },
            {
              content: '研产协同中台：打通配方设计（支持多维度参数模拟）、工艺参数协同、配方自动下发，试产周期压缩30%'
            },
            {
              content: '实时数据共享：实现研发与生产部门的实时数据共享，确保配方变更及时传递到生产环节，减少沟通成本。配方变更的平均响应时间从3天缩短至1天，生产效率提升20%'
            },
            {
              content: '数据加密与备份：通过数据加密、用户权限管理和数据备份功能，确保企业数据的安全性和完整性。数据泄露风险从25%降低至5%，数据丢失率从10%降低至2%'
            }
          ]
        },
        {
          num: '07',
          title: '研发生态构建',
          contentList: [
            {
              content: '知识库：支持实验数据的结构化沉淀，支持配方AI智能推荐'
            },
            {
              content: '试验平台：AI优化检测方案（如稳定性测试关键指标自动筛选），检测报告自动生成，数据异常实时预警'
            }
          ]
        }
      ]
    }
  },
  mounted() {
    this.setSize();
    window.addEventListener("resize", () => {
      this.setSize();
    }, false );

    baiduConsult();
  },
  methods: {
    setSize() {
      this.bannerHeight2 = document.body.clientWidth / (1920 / 450)
      if (document.body.clientWidth < 768) this.bannerHeight2 = 320
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/styles/mixins.scss";

.food-beverage {
  ::v-deep .srm-header {
    padding-right: 8rem;
  }
  ::v-deep .productfeature .tab-container .el-tabs .el-tabs__header .el-tabs__nav .el-tabs__item {
    width: 28rem;
  }
  ::v-deep .productfeature {
    .content-left {
      padding: 0;
      left: 26rem;
      width: 54rem;
    }
    .content-right {
      width: 88.2rem;
      height: 51rem;
      top: 12.7rem;
      right: 17.1rem;
    }
  }
  ::v-deep .point-of-pain {
    .list-item {
      padding-top: 4rem;
      height: 36rem !important;
      .cl-list {
        margin-top: 2.1rem;
      }
    }
    .isThree {
      height: 56rem !important;
    }
    .cl-l-i-content {
      line-height: 2.8rem !important;
    }
  }
  ::v-deep .core-strengths {
    .list-item {
      padding: 1.9rem 2.6rem !important;
      margin-bottom: 1.5rem !important;
    }
  }

  @include mobile-page-overrides;
}
</style>
